import type { JobSalary } from "@lossdog/job-watchlists";
import { useSignals } from "@preact/signals-react/runtime";
import { cx } from "class-variance-authority";

import { NumberUtils } from "@/util/number.utils";

interface Props {
  jobSalary: JobSalary;
}

export const JobSalaryLastPrice = ({ jobSalary }: Props) => {
  useSignals();
  return (
    <span
      className={cx(
        "text-right",
        jobSalary.salaryUp.value && "animate-salary-flash-up text-info-success",
        jobSalary.salaryDown.value && "animate-salary-flash-down text-info-error-2",
      )}
    >
      {NumberUtils.formatAsUSCurrency(jobSalary.salary.value)}
    </span>
  );
};
